import { apiAction } from '../../../../shared/store/apiAction';

import * as api from './api';
import { fetchCategoryDetailsTypes } from './types';

export const fetchCategoryDetails = apiAction({
  types: fetchCategoryDetailsTypes,
  apiAction: api.fetchCategoryDetails,
});
